<template>
  <vonap-window
    :modal="true"
    :visible="value"
    transition="dialog-scale-transition"
    title="Validate All"
    width="320px"
    height="217px"
    @close="close"
  >
    <v-layout row justify-center>
      <v-card>
        <v-container grid-list-xl text-xs-center style="height:132px;width:302px">
          <v-layout row wrap>
            <v-flex xs12>
              <vonap-toolbar-label>
                {{
                  isValid
                    ? 'Are you sure you want to Validate ALL "On Hold" for the selected responsible?'
                    : 'Are you sure you want to Unvalidate ALL "To Be Send" for the selected responsible?'
                }}
              </vonap-toolbar-label>
            </v-flex>
            <v-flex xs12 style="margin-top:-32px">
              <vonap-toolbar-label>
                <v-switch v-model="isValid" label="Validation" />
              </vonap-toolbar-label>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="spacer"></div>
          <v-btn block color="primary" @click="save" :disabled="sending">
            <v-progress-circular indeterminate v-if="sending" />
            {{ isValid ? 'Validate' : 'Unvalidate' }}
          </v-btn>
          <v-btn block color="primary" @click="close">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import VonapWindow from '@/components/VonapWindow'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import notification from '@/helpers/notification'

export default {
  name: 'DashboardBonCoupValidateAllConfirmForm',
  components: {
    VonapWindow,
    VonapToolbarLabel,
  },
  props: {
    value: {type: Boolean},
    asOfDate: {type: String, defaultValue: null},
    responsibleEmail: {type: String},
  },
  mounted() {},
  data() {
    return {
      isValid: true,
      testEmail: '',
      sending: false,
    }
  },
  methods: {
    async save() {
      const data = {
        asOfDate: this.asOfDate,
        responsible: this.responsibleEmail,
        valid: this.isValid,
      }
      this.sending = true
      const response = await axios
        .post('/api/report/monthlyReportSendingList/validateAll', data)
        .catch(() => {
          notification('Some error', 'error')
          this.sending = false
        })

      if (response.status == 200) {
        this.$emit('success')
        notification('Process finished successfully!', 'info')
      }

      this.close()
    },
    close() {
      this.sending = false
      this.isValid = true
      this.$emit('input', false)
    },
  },
  computed: {},
}
</script>
